<div class="main-content">
    <div class="contact-container">
        <h1 class="text-center mb-4" translate>pages.LoginPage.ContactUs</h1>
        <div class="row justify-content-center">
            <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <div class="contact-details blk">
                    <mat-card class="shadow mt-3">
                        <div class="row">
                            <!--<div class="col-12 col-xs-12 col-sm-6">
                                <ul class="list-unstyled">
                                    <li class="list-item">
                                        <h3 class="mb-2"><b> Sales Representative</b></h3>
                                        <p>Name : {{retailerInfo.userName}} </p>
                                        <p>Phone : <a href="tel:{{retailerInfo.phoneNumber}}" target="_blank" class="text-main">{{retailerInfo.phoneNumber}}</a> </p>
                                    </li>
                                    <li class="list-item">
                                        <h3>Email : <a href="mailto:{{retailerInfo. emailId}}" target="_blank" class="text-main"> {{retailerInfo. emailId}}</a></h3>
                                    </li>
                                </ul>
                            </div>-->
                            <div class="col-12">
                                <ul class="list-unstyled">
                                    <li class="list-item">
                                        <h3 class="mb-2"><b>{{'pages.ContactUs.Customerservice' | translate }}</b></h3>
                                        <p class="mb-1">{{ tilaTimings}}</p>
                                        <!-- <p class="mb-1">{{ "pages.ContactUs.Saturday" | translate }} : {{ tilaTimings['Saturday']}}</p>
                                        <p class="mb-1">{{ "pages.ContactUs.Sunday" | translate }} : {{ tilaTimings['Sunday']}}</p> -->
                                        <p class="mb-2">{{'pages.ContactUs.Phone' | translate }} : <a href="tel: {{ tilaMobile }}" target="_blank" class="text-main text-underline">(888) 616-2110</a></p>
                                    </li>
                                    <li class="list-item">
                                        <h3> {{'pages.ContactUs.Email' | translate }} : <a href="mailto:{{tilaEmail}}" target="_blank" class="text-main text-underline"> info@TilaTopUp.com</a></h3>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </mat-card>
                </div>
            </div>
        </div>
    </div>
</div>